import styled from "@emotion/styled";
import React from "react";

type Props = {
  placeholder: string;
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
  onClick: () => void;
  onFocus: () => void;
  value?: string;
  onChange?: (value: string) => void;
};

export default function ScaffoldSearchbar(props: Props) {
  return (
    <Root>
      {props.leading}
      <Input
        value={props.value}
        onChange={(event) => props.onChange?.(event.target.value)}
        leadingPadding={props.leading === undefined}
        placeholder={props.placeholder}
        onClick={props.onClick}
        onFocus={props.onFocus}
      />
      {props.trailing}
    </Root>
  );
}

const Input = styled.input<{ leadingPadding: boolean }>`
  border: none;
  background: transparent;
  margin: 0;
  font-family: inherit;
  color: var(--tw-slate-900);
  font-size: 16px;
  font-weight: 600;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-inline-start: ${(props) => (props.leadingPadding ? "16px" : "0")};
  padding-inline-end: 32px;
  flex: 1;

  &::placeholder {
    color: var(--tw-slate-900);
  }
`;

const Root = styled.div`
  background-color: var(--tw-slate-50);
  border-radius: 8px;
  border: 3px solid var(--primary-color);
  display: flex;
  flex: 1;
  transition: outline 0.1s ease;
`;
